import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../../common/axiosInstans.ts';

export interface Organization {
    id: string;
    name: string;
    organizationType: string;
}

export interface UserOrganization {
    organizationId: string;
    organizationName: string;
    isCurrentOrganization: boolean;
}

export interface SwitchOrganizationResponse {
    token: string;
    refreshToken: string;
    refreshTokenExpiryTime: string;
}

class OrganizationService {
    public async getOrganizationTree() {
        try {
            let res = await axiosInstance.get(`/organization/OrganizationTree`);
            return res.data;
        } catch (error) {
            console.error('Error getting organizations.', error);
            throw error;
        }
    }

    public async getOrganizations(): Promise<any[]> {
        try {
            let res = await axiosInstance.get(`/organization`);
            return res.data;
        } catch (error) {
            console.error('Error getting organizations.', error);
            throw error;
        }
    }

    public async createOrganization(formData) {
        try {
            let res = await axiosInstance.post(`/organization`, formData);
            return res.data;
        } catch (error) {
            console.error('Error creating organization.', error);
            throw error;
        }
    }

    public async deleteOrganization(organizationId): Promise<AxiosResponse> {
        try {
            return await axiosInstance.delete(
                `/organization/${organizationId}`
            );
        } catch (error) {
            console.error('Error creating organization.', error);
            throw error;
        }
    }

    public async getOrganization(organizationId) {
        try {
            let res = await axiosInstance.get(
                `/organization/${organizationId}`
            );
            return res.data;
        } catch (error) {
            console.error('Error getting organizations.', error);
            throw error;
        }
    }

    public async updateOrganization(formData) {
        try {
            let res = await axiosInstance.put('/organization', formData);
            if (res.status === 200) {
                return { success: true };
            }
        } catch (error) {
            console.error('Error creating organization.', error);
            throw error;
        }
    }

    /**
     * Get all organizations for the current user
     * @returns Array of user organizations with current organization flag
     */
    public async getMyOrganizations(): Promise<UserOrganization[]> {
        try {
            const res = await axiosInstance.get(
                '/organization/my-organizations'
            );
            return res.data;
        } catch (error) {
            console.error('Error getting user organizations:', error);
            throw error;
        }
    }

    /**
     * Switch to a different organization
     * @param organizationId - The ID of the organization to switch to
     * @returns New JWT tokens with the updated organization
     */
    public async switchOrganization(
        organizationId: string
    ): Promise<SwitchOrganizationResponse> {
        try {
            const res = await axiosInstance.post('/organization/switch', {
                organizationId,
            });
            return res.data;
        } catch (error) {
            console.error('Error switching organization:', error);
            throw error;
        }
    }
}

export default OrganizationService;
